<template lang="pug">
  .loader
    img.loader__img(src="~@/assets/icon-loader.png" alt="Ciclic Seguro Viagem Carregando...")
    p.text {{this.text}}
</template>
<script>
export default {
  name: 'loader',
  props: ['text']
}
</script>

<style scoped lang="scss">
  @keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
  }

  .loader {
    text-align: center;
    max-width: 100%;
    padding: 12px 24px 64px;
  }

  .loader__img {
    height: 48px;
    margin-top: 80px;
    animation-duration: .7s;
    animation: spin 1s ease .5s infinite;
  }

  p.text {
    font-size: 20px;
  }
</style>
